var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",on:{"click":_vm.gotoapk}},[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/yuenan.gif")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }